import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

function DisclaimerPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Show the popup on every page reload
    setOpen(true);
  }, []);

  const handleAccept = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          boxShadow: 4,
          bgcolor: "#f9f9f9",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          bgcolor: "#e0e0e0",
          color: "#333",
          fontWeight: "bold",
          textAlign: "center",
          fontSize: "1.5rem",
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
        }}
      >
        Disclaimer
      </DialogTitle>

      {/* Content */}
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ borderLeft: "4px solid #bdbdbd", pl: 2 }}>
          <Typography variant="body1" sx={{ color: "#444", mb: 2 }}>
            This website is provided for informational purposes only. By
            continuing, you acknowledge and agree to the following:
          </Typography>

          <List dense sx={{ pl: 2 }}>
            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{ color: "#555" }}>
                    <strong>No Solicitation:</strong> The Bar Council of India
                    prohibits the solicitation of work and advertising by legal
                    professionals. This website does not promote such activity.
                  </Typography>
                }
              />
            </ListItem>

            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{ color: "#555" }}>
                    <strong>Informational Use Only:</strong> The content here is
                    for general knowledge and should not be considered legal
                    advice.
                  </Typography>
                }
              />
            </ListItem>

            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{ color: "#555" }}>
                    <strong>No Attorney-Client Relationship:</strong> Accessing
                    this website does not create a legal relationship with ALG.
                  </Typography>
                }
              />
            </ListItem>

            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{ color: "#555" }}>
                    <strong>Cookies & Privacy:</strong> We use cookies to
                    enhance your experience. By proceeding, you agree to our{" "}
                    <a
                      href="/privacy-policy"
                      style={{
                        color: "#757575",
                        textDecoration: "underline",
                      }}
                    >
                      Privacy Policy
                    </a>
                    .
                  </Typography>
                }
              />
            </ListItem>

            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{ color: "#555" }}>
                    <strong>Intellectual Property:</strong> All content on this
                    site is the intellectual property of ALG and is protected by
                    applicable laws.
                  </Typography>
                }
              />
            </ListItem>
          </List>

          <Typography
            variant="h6"
            sx={{
              mt: 3,
              fontWeight: "bold",
              color: "#444",
              textAlign: "center",
            }}
          >
            By proceeding, you confirm that you have read, understood, and
            accepted this disclaimer.
          </Typography>
        </Box>
      </DialogContent>

      {/* Action Button */}
      <DialogActions
        sx={{
          bgcolor: "#f0f0f0",
          justifyContent: "center",
          p: 2,
          borderBottomLeftRadius: "16px",
          borderBottomRightRadius: "16px",
        }}
      >
        <Button
          onClick={handleAccept}
          variant="contained"
          sx={{
            fontWeight: "bold",
            px: 4,
            py: 1.5,
            borderRadius: "8px",
            backgroundColor: "#9e9e9e",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#8e8e8e",
            },
          }}
        >
          I Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DisclaimerPopup;
